import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react';
import httpClient from 'utils/httpClient';

const ClientContext = createContext();

export const useClient = () => useContext(ClientContext);

const ClientProvider = ({ clientId, children }) => {
  const [isLoading, setLoading] = useState(true);
  const [clientData, setClientData] = useState(null);

  const fetchClientDetails = useCallback(async () => {
    setLoading(true); // Ensure loading state resets
    try {
      const response = await httpClient.get(
        `/company/company/detail/?company_id=${clientId}`
      );
      setClientData(response?.data ?? {});
    } catch (error) {
      console.error('Failed to fetch client data:', error);
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  const updateClientData = (newData) => {
    setClientData((prev) => ({ ...prev, ...newData }));
  };

  useEffect(() => {
    fetchClientDetails();
  }, [fetchClientDetails]);

  return (
    <ClientContext.Provider value={{ isLoading, clientData, updateClientData }}>
      {children}
    </ClientContext.Provider>
  );
};

export default ClientProvider;
